"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "wbrc20Proxy",
                type: "address",
            },
        ],
        name: "Brc20Removed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "remainingAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "inputToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "outputAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "outputToken",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "protocolFee",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "lockerFee",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "thirdPartyFee",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct IBrc20Router.fees",
                name: "fee",
                type: "tuple",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "txId",
                type: "bytes32",
            },
        ],
        name: "FailedWrapAndSwap",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "decimal",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "wbrc20Proxy",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "wbrc20Logic",
                type: "address",
            },
        ],
        name: "NewBrc20",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldLocker",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newLocker",
                type: "address",
            },
        ],
        name: "NewLocker",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldProtocolPercentageFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newProtocolPercentageFee",
                type: "uint256",
            },
        ],
        name: "NewProtocolPercentageFee",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldRelay",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newRelay",
                type: "address",
            },
        ],
        name: "NewRelay",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldTeleporter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newTeleporter",
                type: "address",
            },
        ],
        name: "NewTeleporter",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldTreasury",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newTreasury",
                type: "address",
            },
        ],
        name: "NewTreasury",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userScript",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "enum ScriptTypes",
                name: "scriptType",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "address",
                name: "inputToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "inputAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "remainingAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lockerFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "protocolFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reqIdx",
                type: "uint256",
            },
        ],
        name: "NewUnwrap",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userScript",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "enum ScriptTypes",
                name: "scriptType",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "inputAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "inputToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "outputAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "remainingAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "outputToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "lockerFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "protocolFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reqIdx",
                type: "uint256",
            },
        ],
        name: "NewUnwrapAndSwap",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "remainingAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "inputToken",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "protocolFee",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "lockerFee",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "thirdPartyFee",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct IBrc20Router.fees",
                name: "fee",
                type: "tuple",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "txId",
                type: "bytes32",
            },
        ],
        name: "NewWrap",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "remainingAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "inputToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "outputAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "outputToken",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "protocolFee",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "lockerFee",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "thirdPartyFee",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct IBrc20Router.fees",
                name: "fee",
                type: "tuple",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "txId",
                type: "bytes32",
            },
        ],
        name: "NewWrapAndSwap",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "appId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "exchangeConnector",
                type: "address",
            },
        ],
        name: "SetExchangeConnector",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "thirdPartyId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "oldAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "oldFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newFee",
                type: "uint256",
            },
        ],
        name: "ThirdPartyInfoUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "wbrc20Proxy",
                type: "address",
            },
        ],
        name: "UnwrapFeeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "remainingAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "userScript",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "enum ScriptTypes",
                name: "scriptType",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reqIdx",
                type: "uint256",
            },
        ],
        name: "UnwrapProcessed",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "_decimal",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
        ],
        name: "addBrc20",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "brc20UnwrapRequests",
        outputs: [
            {
                internalType: "bool",
                name: "isProcessed",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "burntAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "appId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "userScript",
                type: "bytes",
            },
            {
                internalType: "enum ScriptTypes",
                name: "scriptType",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "brc20WrapRequests",
        outputs: [
            {
                internalType: "bool",
                name: "isUsed",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "appId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "inputAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "inputToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipientAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "thirdPartyId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "fee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "outputAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "outputToken",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "exchangeConnector",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_startingBlockNumber",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_protocolPercentageFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_relay",
                type: "address",
            },
            {
                internalType: "address",
                name: "_locker",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_lockerLockingScript",
                type: "bytes",
            },
            {
                internalType: "enum ScriptTypes",
                name: "_lockerScriptType",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "_teleporter",
                type: "address",
            },
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_reqIdx",
                type: "uint256",
            },
        ],
        name: "isUnwrapRequestProcessed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_txId",
                type: "bytes32",
            },
        ],
        name: "isWrapRequestProcessed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "locker",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockerLockingScript",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockerPercentageFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockerScriptType",
        outputs: [
            {
                internalType: "enum ScriptTypes",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolPercentageFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "relay",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
        ],
        name: "removeBrc20",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_chainId",
                type: "uint256",
            },
        ],
        name: "setChainId",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_appId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_exchangeConnector",
                type: "address",
            },
        ],
        name: "setExchangeConnector",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_locker",
                type: "address",
            },
        ],
        name: "setLocker",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_lockerLockingScript",
                type: "bytes",
            },
            {
                internalType: "enum ScriptTypes",
                name: "_lockerScriptType",
                type: "uint8",
            },
        ],
        name: "setLockerLockingScript",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_protocolPercentageFee",
                type: "uint256",
            },
        ],
        name: "setProtocolPercentageFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_relay",
                type: "address",
            },
        ],
        name: "setRelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_startingBlockNumber",
                type: "uint256",
            },
        ],
        name: "setStartingBlockNumber",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_teleporter",
                type: "address",
            },
        ],
        name: "setTeleporter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_thirdPartyId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_thirdPartyAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_thirdPartyFee",
                type: "uint256",
            },
        ],
        name: "setThirdParty",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_treasury",
                type: "address",
            },
        ],
        name: "setTreasury",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "setUnwrapFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "startingBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "supportedBrc20s",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "teleporter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "thirdParties",
        outputs: [
            {
                internalType: "address",
                name: "thirdPartyAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "thirdPartyFee",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        name: "tokenIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "treasury",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_userScript",
                type: "bytes",
            },
            {
                internalType: "enum ScriptTypes",
                name: "_scriptType",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "_appId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_inputAmount",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "_path",
                type: "address[]",
            },
        ],
        name: "unwrapBrc20",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unwrapCounter",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "unwrapFees",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_version",
                type: "bytes4",
            },
            {
                internalType: "bytes",
                name: "_vin",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_vout",
                type: "bytes",
            },
            {
                internalType: "bytes4",
                name: "_locktime",
                type: "bytes4",
            },
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_intermediateNodes",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
            {
                internalType: "uint256[]",
                name: "_reqIndexes",
                type: "uint256[]",
            },
        ],
        name: "unwrapProof",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "_version",
                type: "bytes4",
            },
            {
                internalType: "bytes",
                name: "_vin",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "_vout",
                type: "bytes",
            },
            {
                internalType: "bytes4",
                name: "_locktime",
                type: "bytes4",
            },
            {
                internalType: "uint256",
                name: "_blockNumber",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_intermediateNodes",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "_path",
                type: "address[]",
            },
        ],
        name: "wrapBrc20",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
//# sourceMappingURL=Brc20RouterLogic.js.map